@if (users.length) {
  <cdk-virtual-scroll-viewport
    class="h-full min-h-0 overflow-y-auto overflow-x-hidden !p-0"
    [itemSize]="itemSizePx"
    [minBufferPx]="minBufferPx"
    [maxBufferPx]="maxBufferPx"
  >
    <app-user-list-item
      *cdkVirtualFor="let user of users; trackBy: trackByUserId"
      [user]="user"
      [clients]="getClientNames(user)"
      [isSelected]="selectedUserId === user.user_id"
    />
  </cdk-virtual-scroll-viewport>
} @else {
  <div class="flex flex-col justify-center items-center h-full">
    <p>No users</p>
  </div>
}
